<template>
	<div>
        <v-client-table :columns="columns" :data="data" :options="options" ref="all" class="screenings-table">
            <div slot="beforeFilter" class="intro">
                <h2>{{ headline }}</h2>
            </div>
            <div slot="afterFilter" class="add-button">

                <div class="data-input select-field sorting" style="">
                    <div class="select-container">
                        <select v-model="propertiesSorting" v-on:change="setTableSorting('all', propertiesSorting)">
                            <option value="">{{ $t('sort.newest-first') }}</option>
                            <option value="10">{{ $t('sort.oldest-first') }}</option>
                            <option value="50">{{ $t('sort.candidate-ascending') }}</option>
                            <option value="40">{{ $t('sort.status-ascending') }}</option>
                            <option value="20">{{ $t('sort.address-ascending') }}</option>
                            <option value="30">{{ $t('sort.zipcode-ascending') }}</option>
                        </select>
                        <span class="arrow">
                            <SvgIcon icon="sort-icon" />
                        </span>
                    </div>
                </div>
                <form>
                    <div class="icon">
                        <SvgIcon icon="search" />
                    </div>
                    <input type="text" v-model="filterText" v-on:keyup="filterTable('all')" autofill="off" autocomplete="false" :placeholder="$t('search.filterplaceholder')">
                </form>
                <router-link disabled to="#" class="button green">
                    <SvgIcon icon="plus-circle" />
                    {{$t('screening.new.button')}}
                </router-link>
            </div>

            <div slot="email" slot-scope="props" class="data-label" :data-label="$t('properties.table.screenings.candidate')">
                <span v-if="props.row.status == 'requested'">
                    {{ props.row.email }}
                </span>
                <a v-else
                    v-on:click="open(props.row)" class="row-link">
                    <span>{{ props.row.email }}</span>
                </a>
                <div v-if="props.row.status == 'requested'" class="background"></div>
            </div>
            <!-- STATUS -->
            <div slot="status" class="data-label" :data-label="$t('properties.table.screenings.status')" slot-scope="props">
                <span>{{ props.row.status_text }}</span>
            </div>
            <!-- DEADLINE -->
            <div slot="deadlineOutput" class="data-label" :data-label="$t('properties.table.screenings.deadline')" slot-scope="props">
                <span>{{ props.row.deadlineOutput }}</span>
            </div>
            <!-- ADDRESS -->
            <div slot="address" class="data-label" :data-label="$t('properties.table.screenings.address')" slot-scope="props">
                <span>{{ props.row.address }}</span>
                <span class="city-info"> {{ props.row.city }}</span>
            </div>
            <!-- CITY -->
            <div slot="city" class="data-label" :data-label="$t('properties.table.screenings.city')" slot-scope="props">
                <span>{{ props.row.city }}</span>
            </div>

            <a slot="more" slot-scope="props">
                <table-dropdown>
                    <li v-if="Number(props.row.tenant_id) > 0" v-on:click="openScreening(props.row)">{{$t('screenings.view')}}</li>
                    <li v-on:click="deleteScreening(props.row.id)">{{$t('screenings.delete')}}</li>
                </table-dropdown>
            </a>
        </v-client-table>
	</div>
</template>

<script>
    import Vue from 'vue';
    import TableDropdown from '../components/TableDropdown';
    import {ClientTable} from 'vue-tables-2';
    import SvgIcon from '../components/Svg.vue';
    import createEntity from "../mixins/create-entity";
    Vue.use(ClientTable);

	export default {
		props: [
			'data',
			'headline',
		],
        mixins: [createEntity],
        components:{
            TableDropdown,
            SvgIcon,
        },
		data: () => ({
            propertiesSorting: '',
            filterText: '',
			columns: ['email', 'status', 'deadlineOutput', 'address', 'city', 'more'],
            options: {
                headings: {
                    email: 'Candidate',
                    status: 'Status',
                    deadlineOutput: 'Deadline',
                    address: 'Address',
                    city: 'City',
                    more: 'More'
                },
                sortable: ['email', 'status'],
                filterable: ['email', 'status', 'address', 'city'],
                texts: {
                    filterPlaceholder: 'Search',
                    filter: '',
                    noResults: ''
                },
                columnsClasses:{
                    email: 'candidate',
                    status: 'screening-status',
                    deadlineOutput: 'deadline',
                    address: 'address',
                    city: 'city',
                    more: 'more'
                },
                customSorting: {
                    oldFirst: function (ascending) {
                        return function (a, b) {
                            return ascending ? -1 : 1;
                        }
                    }
                }
            },
		}),
		methods: {
            open(row) {
                if (Number(row.tenant_id) > 0) {
                    this.openScreening(row);
                } else {
                    this.openFinalization(row.id);
                }
            },
            filterTable(ref, value) {
                this.$refs[ref].setFilter(this.filterText);
            },
            setTableSorting(ref, algo) {
                switch (String(algo)) {
                    case '':
                        this.$refs[ref].setOrder('oldFirst', false);
                        break;
                    case '10':
                        this.$refs[ref].setOrder('oldFirst', true);
                        break;
                    case '20':
                        this.$refs[ref].setOrder('address', true);
                        break;
                    case '30':
                        this.$refs[ref].setOrder('city', true);
                        break;
                    case '40':
                        this.$refs[ref].setOrder('status', true);
                        break;
                    case '50':
                        this.$refs[ref].setOrder('email', true);
                        break;
                }
            },
            openFinalization(id) {
                var rows = this.data;
                for (var i in rows) {
                    var row = rows[i];
                    if (row.id == id) {
                        if (row.status != 'draft') {
                            // 0 Is "nobody" - loads empty screening
                            this.$router.push('/tenant-profile/' + (row.tenant_id ? row.tenant_id : '0?property=' + row.property.id));
                        } else {
                            this.$router.push('/screenings/'+id+'/send');
                        }
                    }
                }
            },
            openScreening(row) {
                if (Number(row.tenant_id) > 0) {
                    this.$router.push('/screenings/tenant-profile/'+row.tenant_id);
                } else {
                    this.$router.push('/screenings/tenant-profile/0?property=' + row.property.id);
                }
            },
            deleteScreening(id) {
                if (confirm('Are you sure?')) {
                    axios({
                        method: 'DELETE',
                        url: window.config.apiUrl + 'api/invitation/' + id,
                        cancelToken: window.AuthorizationCancelSource.token,
                    }).then(response => {
                        location.reload();
                    });
                }
            },
		},
		created() {
            this.options.headings.email = this.$t('properties.table.screenings.candidate');
            this.options.headings.status = this.$t('properties.table.screenings.status');
            this.options.headings.address = this.$t('properties.table.screenings.address');
            this.options.headings.city = this.$t('properties.table.screenings.city');
            this.options.headings.deadline = this.$t('properties.table.screenings.deadline');
            this.options.headings.more = this.$t('tables.more.label');
            this.options.texts.filterPlaceholder = this.$t('search.filterplaceholder');
            this.options.texts.noResults = this.$t('table.no-results.label');
		},
	}
</script>
